import React, { useState, useEffect } from 'react';
import '../styles/components/NavigationHeader.css';

const NavigationHeader: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offsetTop = element.offsetTop - 50; // Account for fixed header
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
      // Close mobile menu after navigation
      setIsMobileMenuOpen(false);
    }
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className={`navigation ${isScrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <div className="nav-logo">
          <img 
            src={require('../assets/images/RushHour_logo_v2.png')} 
            alt="RushHour Logo" 
            className="nav-logo-img" 
          />
          <span className="nav-logo-text">RushHour</span>
        </div>
        
        {/* Hamburger Menu Button */}
        <button 
          className={`hamburger-menu ${isMobileMenuOpen ? 'active' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle navigation menu"
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>
        
        {/* Desktop Navigation Links */}
        <div className="nav-links desktop-nav">
          <button 
            onClick={() => scrollToSection('hero')}
            className="nav-link"
          >
            Home
          </button>
          <button 
            onClick={() => scrollToSection('problem-solution')}
            className="nav-link"
          >
            Problem
          </button>
          <button 
            onClick={() => scrollToSection('features')}
            className="nav-link"
          >
            Features
          </button>
          <button 
            onClick={() => scrollToSection('screenshots')}
            className="nav-link"
          >
            Screenshots
          </button>
          <button 
            onClick={() => scrollToSection('get-app')}
            className="nav-link"
          >
            Download
          </button>
        </div>
        
        {/* Mobile Navigation Menu */}
        <div className={`mobile-nav ${isMobileMenuOpen ? 'open' : ''}`}>
          <button 
            onClick={() => scrollToSection('hero')}
            className="nav-link mobile-nav-link"
          >
            Home
          </button>
          <button 
            onClick={() => scrollToSection('problem-solution')}
            className="nav-link mobile-nav-link"
          >
            Problem
          </button>
          <button 
            onClick={() => scrollToSection('features')}
            className="nav-link mobile-nav-link"
          >
            Features
          </button>
          <button 
            onClick={() => scrollToSection('screenshots')}
            className="nav-link mobile-nav-link"
          >
            Screenshots
          </button>
          <button 
            onClick={() => scrollToSection('get-app')}
            className="nav-link mobile-nav-link"
          >
            Download
          </button>
        </div>
      </div>
    </nav>
  );
};

export default NavigationHeader;
